import { m } from '@/lib/paraglide/messages'

// Nhãn tiếng Việt cho đơn vị vật tư nông nghiệp. `material_unit` lưu DB dạng
// enum tiếng Anh (kg/bag/bottle/pack) khớp hệ cũ; UI hiển thị nhãn tiếng Việt.
const LABELS: Record<string, () => string> = {
    kg: () => m.agri_unit_kg(),
    bag: () => m.agri_unit_bag(),
    bottle: () => m.agri_unit_bottle(),
    pack: () => m.agri_unit_pack(),
}

/** Trả nhãn tiếng Việt cho đơn vị; fallback nguyên chuỗi nếu đơn vị lạ, '' nếu rỗng. */
export function agriUnitLabel(unit?: string | null): string {
    if (!unit) return ''
    return LABELS[unit]?.() ?? unit
}
